module.exports = __webpack_public_path__ + "img/shield.e04857f9.png";